<template>
    <kiosk-group-details :teamId="props.teamId" :groupId="props.groupId">
        <div class="flex flex-col w-full max-w-(--breakpoint-sm) justify-center">
            <page-callout section="kiosk-group-configuration" class="mb-4" />

            <page-header>Configuration</page-header>

            <update-group-hubspot
                :teamId="props.teamId"
                :groupId="props.groupId"
                :isEditable="props.teamStatus !== 'closed'"
                class="mb-4"
            />

            <update-group-status
                :teamId="props.teamId"
                :groupId="props.groupId"
                :isEditable="props.teamStatus !== 'closed'"
                class="mb-4"
            />
        </div>
    </kiosk-group-details>
</template>

<script lang="ts" setup>
import KioskGroupDetails from '~/components/kiosk/kiosk-groups/details/KioskGroupDetails.vue';
import PageHeader from '~/components/general/PageHeader.vue';
import PageCallout from '~/components/general/PageCallout.vue';
import UpdateGroupHubspot from '~/components/kiosk/kiosk-groups/configuration/UpdateGroupHubspot.vue';
import UpdateGroupStatus from '~/components/kiosk/kiosk-groups/configuration/UpdateGroupStatus.vue';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
    groupId: {
        type: String,
        required: true,
    },
    teamStatus: {
        type: String,
        required: true,
    },
});
</script>
